import z from "zod";

export const costTypeSchema = z.object({
	id: z.number().nullable(),
	title_en: z.string().min(1).max(255),
	title_nl: z.string().min(1).max(255),
	title_de: z.string().min(1).max(255),
});

export type CostTypeSchemaInput = z.input<typeof costTypeSchema>;
export type CostTypeSchemaOutput = z.output<typeof costTypeSchema>;

export const costTypeSelectOptionSchema = z.object({
	id: z.number(),
	title_en: z.string().nullable().optional(),
	title_nl: z.string().nullable().optional(),
	title_de: z.string().nullable().optional(),
});
